export default {
 "columns": 18,
 "image": "underwater-debris.png",
 "imageheight": 240,
 "imagewidth": 288,
 "margin": 0,
 "name": "underwater-debris",
 "spacing": 0,
 "tilecount": 270,
 "tiledversion": "1.11.2",
 "tileheight": 16,
 "tilewidth": 16,
 "type": "tileset",
 "version": "1.10",
 "tiles": [
  {
   "id": 0,
   "type": "decal"
  },
  {
   "id": 1,
   "type": "decal"
  },
  {
   "id": 2,
   "type": "decal"
  },
  {
   "id": 3,
   "type": "decal"
  },
  {
   "id": 4,
   "type": "decal"
  },
  {
   "id": 5,
   "type": "decal"
  },
  {
   "id": 7,
   "type": "decal"
  },
  {
   "id": 8,
   "type": "decal"
  },
  {
   "id": 15,
   "type": "decal"
  },
  {
   "id": 16,
   "type": "decal"
  },
  {
   "id": 18,
   "type": "decal"
  },
  {
   "id": 19,
   "type": "decal"
  },
  {
   "id": 20,
   "type": "decal"
  },
  {
   "id": 21,
   "type": "decal"
  },
  {
   "id": 22,
   "type": "decal"
  },
  {
   "id": 23,
   "type": "decal"
  },
  {
   "id": 25,
   "type": "decal"
  },
  {
   "id": 26,
   "type": "decal"
  },
  {
   "id": 33,
   "type": "decal"
  },
  {
   "id": 34,
   "type": "decal"
  },
  {
   "id": 35,
   "type": "decal"
  },
  {
   "id": 36,
   "type": "decal"
  },
  {
   "id": 37,
   "type": "decal"
  },
  {
   "id": 38,
   "type": "decal"
  },
  {
   "id": 39,
   "type": "decal"
  },
  {
   "id": 40,
   "type": "decal"
  },
  {
   "id": 41,
   "type": "decal"
  },
  {
   "id": 44,
   "type": "decal"
  },
  {
   "id": 51,
   "type": "decal"
  },
  {
   "id": 52,
   "type": "decal"
  },
  {
   "id": 53,
   "type": "decal"
  },
  {
   "id": 54,
   "type": "decal"
  },
  {
   "id": 55,
   "type": "decal"
  },
  {
   "id": 56,
   "type": "decal"
  },
  {
   "id": 57,
   "type": "decal"
  },
  {
   "id": 58,
   "type": "decal"
  },
  {
   "id": 59,
   "type": "decal"
  },
  {
   "id": 61,
   "type": "decal"
  },
  {
   "id": 62,
   "type": "decal"
  },
  {
   "id": 65,
   "type": "decal"
  },
  {
   "id": 66,
   "type": "decal"
  },
  {
   "id": 67,
   "type": "decal"
  },
  {
   "id": 68,
   "type": "decal"
  },
  {
   "id": 69,
   "type": "decal"
  },
  {
   "id": 70,
   "type": "decal"
  },
  {
   "id": 72,
   "type": "decal"
  },
  {
   "id": 73,
   "type": "decal"
  },
  {
   "id": 74,
   "type": "decal"
  },
  {
   "id": 75,
   "type": "decal"
  },
  {
   "id": 76,
   "type": "decal"
  },
  {
   "id": 77,
   "type": "decal"
  },
  {
   "id": 78,
   "type": "decal"
  },
  {
   "id": 79,
   "type": "decal"
  },
  {
   "id": 80,
   "type": "decal"
  },
  {
   "id": 81,
   "type": "decal"
  },
  {
   "id": 82,
   "type": "decal"
  },
  {
   "id": 83,
   "type": "decal"
  },
  {
   "id": 84,
   "type": "decal"
  },
  {
   "id": 85,
   "type": "decal"
  },
  {
   "id": 86,
   "type": "decal"
  },
  {
   "id": 87,
   "type": "decal"
  },
  {
   "id": 88,
   "type": "decal"
  },
  {
   "id": 89,
   "type": "decal"
  },
  {
   "id": 90,
   "type": "decal"
  },
  {
   "id": 91,
   "type": "decal"
  },
  {
   "id": 93,
   "type": "decal"
  },
  {
   "id": 94,
   "type": "decal"
  },
  {
   "id": 95,
   "type": "decal"
  },
  {
   "id": 96,
   "type": "decal"
  },
  {
   "id": 99,
   "type": "decal"
  },
  {
   "id": 100,
   "type": "decal"
  },
  {
   "id": 101,
   "type": "decal"
  },
  {
   "id": 102,
   "type": "decal"
  },
  {
   "id": 103,
   "type": "decal"
  },
  {
   "id": 104,
   "type": "decal"
  },
  {
   "id": 105,
   "type": "decal"
  },
  {
   "id": 106,
   "type": "decal"
  },
  {
   "id": 107,
   "type": "decal"
  },
  {
   "id": 108,
   "type": "decal"
  },
  {
   "id": 109,
   "type": "decal"
  },
  {
   "id": 110,
   "type": "decal"
  },
  {
   "id": 111,
   "type": "decal"
  },
  {
   "id": 112,
   "type": "decal"
  },
  {
   "id": 113,
   "type": "decal"
  },
  {
   "id": 114,
   "type": "decal"
  },
  {
   "id": 116,
   "type": "decal"
  },
  {
   "id": 117,
   "type": "decal"
  },
  {
   "id": 118,
   "type": "decal"
  },
  {
   "id": 119,
   "type": "decal"
  },
  {
   "id": 120,
   "type": "decal"
  },
  {
   "id": 122,
   "type": "decal"
  },
  {
   "id": 126,
   "type": "decal"
  },
  {
   "id": 127,
   "type": "decal"
  },
  {
   "id": 128,
   "type": "decal"
  },
  {
   "id": 129,
   "type": "decal"
  },
  {
   "id": 130,
   "type": "decal"
  },
  {
   "id": 131,
   "type": "decal"
  },
  {
   "id": 132,
   "type": "decal"
  },
  {
   "id": 133,
   "type": "decal"
  },
  {
   "id": 134,
   "type": "decal"
  },
  {
   "id": 135,
   "type": "decal"
  },
  {
   "id": 136,
   "type": "decal"
  },
  {
   "id": 137,
   "type": "decal"
  },
  {
   "id": 138,
   "type": "decal"
  },
  {
   "id": 139,
   "type": "decal"
  },
  {
   "id": 140,
   "type": "decal"
  },
  {
   "id": 141,
   "type": "decal"
  },
  {
   "id": 142,
   "type": "decal"
  },
  {
   "id": 143,
   "type": "decal"
  },
  {
   "id": 144,
   "type": "decal"
  },
  {
   "id": 145,
   "type": "decal"
  },
  {
   "id": 146,
   "type": "decal"
  },
  {
   "id": 147,
   "type": "decal"
  },
  {
   "id": 148,
   "type": "decal"
  },
  {
   "id": 149,
   "type": "decal"
  },
  {
   "id": 150,
   "type": "decal"
  },
  {
   "id": 151,
   "type": "decal"
  },
  {
   "id": 154,
   "type": "decal"
  },
  {
   "id": 155,
   "type": "decal"
  },
  {
   "id": 157,
   "type": "decal"
  },
  {
   "id": 158,
   "type": "decal"
  },
  {
   "id": 159,
   "type": "decal"
  },
  {
   "id": 160,
   "type": "decal"
  },
  {
   "id": 161,
   "type": "decal"
  },
  {
   "id": 165,
   "type": "decal"
  },
  {
   "id": 166,
   "type": "decal"
  },
  {
   "id": 167,
   "type": "decal"
  },
  {
   "id": 169,
   "type": "decal"
  },
  {
   "id": 174,
   "type": "decal"
  },
  {
   "id": 175,
   "type": "decal"
  },
  {
   "id": 176,
   "type": "decal"
  },
  {
   "id": 177,
   "type": "decal"
  },
  {
   "id": 178,
   "type": "decal"
  },
  {
   "id": 179,
   "type": "decal"
  },
  {
   "id": 183,
   "type": "decal"
  },
  {
   "id": 184,
   "type": "decal"
  },
  {
   "id": 185,
   "type": "decal"
  },
  {
   "id": 186,
   "type": "decal"
  },
  {
   "id": 190,
   "type": "decal"
  },
  {
   "id": 191,
   "type": "decal"
  },
  {
   "id": 192,
   "type": "decal"
  },
  {
   "id": 193,
   "type": "decal"
  },
  {
   "id": 194,
   "type": "decal"
  },
  {
   "id": 195,
   "type": "decal"
  },
  {
   "id": 196,
   "type": "decal"
  },
  {
   "id": 197,
   "type": "decal"
  },
  {
   "id": 199,
   "type": "decal"
  },
  {
   "id": 200,
   "type": "decal"
  },
  {
   "id": 201,
   "type": "decal"
  },
  {
   "id": 202,
   "type": "decal"
  },
  {
   "id": 203,
   "type": "decal"
  },
  {
   "id": 204,
   "type": "decal"
  },
  {
   "id": 206,
   "type": "decal"
  },
  {
   "id": 207,
   "type": "decal"
  },
  {
   "id": 208,
   "type": "decal"
  },
  {
   "id": 209,
   "type": "decal"
  },
  {
   "id": 210,
   "type": "decal"
  },
  {
   "id": 211,
   "type": "decal"
  },
  {
   "id": 212,
   "type": "decal"
  },
  {
   "id": 213,
   "type": "decal"
  },
  {
   "id": 214,
   "type": "decal"
  },
  {
   "id": 215,
   "type": "decal"
  },
  {
   "id": 217,
   "type": "decal"
  },
  {
   "id": 218,
   "type": "decal"
  },
  {
   "id": 219,
   "type": "decal"
  },
  {
   "id": 220,
   "type": "decal"
  },
  {
   "id": 222,
   "type": "decal"
  },
  {
   "id": 223,
   "type": "decal"
  },
  {
   "id": 224,
   "type": "decal"
  },
  {
   "id": 225,
   "type": "decal"
  },
  {
   "id": 226,
   "type": "decal"
  },
  {
   "id": 227,
   "type": "decal"
  },
  {
   "id": 228,
   "type": "decal"
  },
  {
   "id": 229,
   "type": "decal"
  },
  {
   "id": 230,
   "type": "decal"
  },
  {
   "id": 231,
   "type": "decal"
  },
  {
   "id": 232,
   "type": "decal"
  },
  {
   "id": 233,
   "type": "decal"
  },
  {
   "id": 235,
   "type": "decal"
  },
  {
   "id": 236,
   "type": "decal"
  },
  {
   "id": 237,
   "type": "decal"
  },
  {
   "id": 238,
   "type": "decal"
  },
  {
   "id": 240,
   "type": "decal"
  },
  {
   "id": 241,
   "type": "decal"
  },
  {
   "id": 242,
   "type": "decal"
  },
  {
   "id": 243,
   "type": "decal"
  },
  {
   "id": 244,
   "type": "decal"
  },
  {
   "id": 245,
   "type": "decal"
  },
  {
   "id": 246,
   "type": "decal"
  },
  {
   "id": 247,
   "type": "decal"
  },
  {
   "id": 248,
   "type": "decal"
  },
  {
   "id": 249,
   "type": "decal"
  },
  {
   "id": 250,
   "type": "decal"
  },
  {
   "id": 251,
   "type": "decal"
  },
  {
   "id": 265,
   "type": "decal"
  },
  {
   "id": 266,
   "type": "decal"
  },
  {
   "id": 267,
   "type": "decal"
  },
  {
   "id": 268,
   "type": "decal"
  },
  {
   "id": 269,
   "type": "decal"
  }
 ]
};